import { Language } from "./Language";
import { Opakowanie } from "./Opakowanie";
import { createRevisionClassResource, RevisionActions } from "../../revision";
import { RevisionItem } from "../RevisionItem";
import {
  itemApiField,
  apiField,
  itemArrayApiField,
  constructFromApiData,
  getApiPostData,
  getDiff,
  revisionItemApiField,
  decimalApiField,
  revisionApiField,
} from "../ResourceItemMetadata";
import { ResourceItem, IncompleteResourceItem } from "../ResourceItem";
import { JednostkaSprzedazy } from "./JednostkaSprzedazy";
import Decimal from "decimal.js";
import { getDumpAction } from "../../dump";
import MegaraxClient from "../../megaraxClient";
import { Brand } from "./Brand";

class WyrobData {
  @itemApiField(ResourceItem, { readOnly: true })
  brand?: Brand;
  @apiField()
  nazwaHandlowa?: string;
  @itemApiField(ResourceItem, { readOnly: true })
  jednostkaSprzedazy?: JednostkaSprzedazy;

  constructor(data: any) {
    constructFromApiData(this, data);
  }
}

class ProduktData {
  @apiField({ readOnly: true })
  nrCn?: string;
  @apiField({ readOnly: true })
  nrPkwiu?: string;

  constructor(data: any) {
    constructFromApiData(this, data);
  }
}

export class Asortyment extends RevisionItem {
  @apiField()
  name!: string;

  @revisionApiField()
  wyrob!: IncompleteResourceItem | null;
  @apiField()
  nazwaNaFakturze: string = "";
  @itemApiField(ResourceItem)
  jezyk: Language | null = null;
  @itemArrayApiField(ResourceItem)
  jezykiNaglowkow: Language[] = [];
  @itemArrayApiField(ResourceItem)
  jezykiOpisuTechnicznego: Language[] = [];

  @decimalApiField()
  wielkoscNaOpakowaniu!: Decimal;
  @decimalApiField()
  masaNetto: Decimal | null = null;
  @decimalApiField()
  objetoscWkladu: Decimal | null = null;

  @itemApiField(ResourceItem)
  opakowanie: Opakowanie | null = null;
  @apiField()
  kodKreskowy?: string;

  wyrobData!: WyrobData | null;
  produktData!: ProduktData | null;

  constructor(data?: any) {
    super(data);

    if (data) {
      constructFromApiData(this, data);
      this.wyrobData = data.wyrobData ? new WyrobData(data.wyrobData) : null;
      this.produktData = data.produktData
        ? new ProduktData(data.produktData)
        : null;
    }
  }

  toString() {
    return this.id!.toString();
  }

  getPostData() {
    return { ...getApiPostData(this), ...super.getPostData() };
  }

  getDiff(other: this) {
    return getDiff(this, other);
  }
}

const dumpLabels = [
  { key: "name", header: "indeksAsortymentu" },
  { key: "wyrobName", header: "indeksWyrobu" },
  { key: "nazwaNaFakturze", header: "nazwaNaFakturze" },
  { key: "wielkoscNaOpakowaniu", header: "wielkoscNaOpakowaniu" },
  { key: "masaNetto", header: "masaNetto" },
  { key: "brandStr", header: "markaHandlowa" },
  { key: "nazwaHandlowa", header: "nazwaHandlowa" },
  { key: "jednostkaSprzedazyStr", header: "jednostkaSprzedazy" },
  { key: "produktName", header: "indeksProduktu" },
  { key: "productGroupStr", header: "grupaProduktowa" },
];

export const asortymentResource = (client: MegaraxClient) => ({
  ...createRevisionClassResource("plm/asortyment/", Asortyment)(client),
  dump: getDumpAction("plm/asortyment/", dumpLabels)(client),
});
